module.exports = __webpack_public_path__ + "static/media/jinengfenlei21.21d649b4.png";